import { useContext, useEffect, useRef } from "react";
import { useDrop } from "react-dnd";
import { DraggableQuestion } from "../DraggableQuestion";
import ProfileQuestionContext from "../../../../contexts/ProfileQuestionContext";
import request from "../../../../utilities/requests";

const QuestionList = () => {
  const { questions, setQuestions, setQuestionGroupQuestions, questionGroup, questionGroupMessage, setQuestionGroupMessage, setRequiredQuestions } =
    useContext(ProfileQuestionContext);
  const questionGroupRef = useRef(questionGroup);

  // Update the ref whenever questionGroup changes
  useEffect(() => {
    questionGroupRef.current = questionGroup;
  }, [questionGroup]);

  const updateQuestionGroup = async (item) => {
    const body = {
      questionGroupId: questionGroupRef.current,
      remove: [item._id],
    };
    const result = await request("questiongroups/update", "post", body);
    if (result.success) {
      setRequiredQuestions(result.questionGroup.required)
      if (result.message) {
        setQuestionGroupMessage(result.message);
      } else {
        setQuestionGroupMessage("");
      }
    }
  };

  const [{ isOver }, dropRef] = useDrop(() => ({
    accept: "QUESTION",
    drop: (item, monitor) => {
      setQuestions((prevQuestions) => {
        // Avoid duplicates
        if (prevQuestions.some((q) => q._id === item._id)) return prevQuestions;
        return [...prevQuestions, { _id: item._id, question: item.question }];
      });
      setQuestionGroupQuestions((prev) =>
        prev.filter((q) => q._id !== item._id)
      );
      updateQuestionGroup(item);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  return (
    <div
      ref={dropRef}
      style={{
        height: "100%",
        border: "1px solid black",
        padding: 10,
        backgroundColor: isOver ? "lightblue" : "white",
      }}
    >
      <h3>Question List</h3>
      {questions.map((question) => (
        <DraggableQuestion key={question._id} question={question} />
      ))}
    </div>
  );
};

export default QuestionList;
